<template>
  <div class="withdrawal-page safe-area-wrapper">
    <!-- 提现表单 -->
    <van-cell-group inset style="margin: 15px; padding: 5px 0 15px 0">
      <van-field
        v-model="form.money"
        type="number"
        label="提现金额"
        placeholder="输入金额"
        required
        @blur="calcFee"
      >
        <template #label>
          <span>申请金额</span>
          <span style="font-size: 8px;">（实收）</span>
        </template>
      </van-field>
      <van-field v-if="accountColumns.length>0"
        v-model="selectedAccountName"
        is-link
        readonly
        label="提现账户"
        placeholder="请选择提现账户"
        required
        @click="showAccountPicker=true"
      />
      <van-cell
        v-else
        required
        title="提现账户"
        value="去绑定账户"
        is-link
        center
        :to="{ name: 'AgentAccount', query: { active: 1 } }"
      />
      <van-field v-model="totalFeeDisplayText" disabled input-align="right">
        <template #label>
          <span>成本合计</span>
          <van-icon name="question-o" size="14" color="#999" style="margin-left:4px;" @click="showFeeTip=true" />
        </template>
      </van-field>
      <van-field v-model="totalMoneyDisplay" label="账户扣减 " disabled input-align="right" class="total-text"/>
      <van-field v-model="totalBankDisplay" label="实际到账" disabled input-align="right" class="total-bank-text"/>
    </van-cell-group>

    <!-- 按钮区域（适配底部安全区） -->
    <div class="btn-area safe-area-bottom">
      <van-button type="primary" block round :loading="submitting" @click="onSubmit">确认提现</van-button>
    </div>

    <!-- 规则说明 -->
    <div class="rule-section">
      <div class="rule-item">
        <van-icon name="gold-coin-o" color="#5FB878" size="16" />
        <span class="rule-label">起提/限额：</span>
        <span><span class="highlight">{{ formatMoney(rules.minAmount) }}</span>元起，单笔最高 <span class="highlight">{{ formatMoney(rules.maxMoney) }}</span>元</span>
      </div>
      <div class="rule-item">
        <van-icon name="calendar-o" color="#1E9FFF" size="16" />
        <span class="rule-label">提现频次：</span>
        <span>每日限提 <span class="highlight">{{ rules.maxFrequency }}</span> 次</span>
      </div>
      <div class="rule-item rule-fee">
        <van-icon name="warning-o" color="#FF5722" size="16" />
        <span class="rule-label">成本说明：</span>
        <span class="fee-text">{{ serviceFee }}元/笔手续费 + {{ taxRatioStr }}个税</span>
      </div>
      <div class="rule-item rule-fee">
        <van-icon name="cash-back-record" color="#00aaff" size="16" />
        <span class="rule-label">提现记录：</span>
        <span style="color: #55aa7f;">路径 → （主页）我的 > 提现记录</span>
      </div>
    </div>

    <!-- 账户选择器（微信内弹窗优化） -->
    <van-popup v-model="showAccountPicker" position="bottom" round :style="{ maxHeight: '60vh' }">
      <van-picker
      show-toolbar
        :columns="accountColumns"
        @confirm="onAccountConfirm"
        @cancel="showAccountPicker=false"
        title="选择提现账户"
      />
    </van-popup>

    <!-- 微信环境提示弹窗 -->
    <van-dialog v-model="showFeeTip" title="成本说明"  confirm-button-text="我知道了">
      <div style="padding:16px;font-size:14px;color:#666;line-height:1.6;">
        手续费：{{ serviceFee }}元/笔<br>
        个税：{{ taxRatioStr }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import {
  withdrawalSubmit
} from '@/api/withdrawal.js'
export default {
  data () {
    return {
      form: { money: '', accountId: '' },
      rules: { minAmount: 100, maxMoney: 10000, maxFrequency: 1 },
      serviceFee: 2,
      taxRatioStr: '9%',
      totalBankDisplay: '',
      totalMoneyDisplay: '',
      totalFeeDisplayText: '',
      totalFeeDisplay: '',
      selectedAccountName: '',
      showAccountPicker: false,
      showFeeTip: false,
      submitting: false
    }
  },
  props: {
    accountList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    accountColumns () {
      return this.accountList.map(a => ({
        text: `${a.realName} (${a.bankAccount})`,
        value: a.accountId
      }))
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData () {
      if (this.accountList.length > 0) {
        this.form.accountId = this.accountList[0].accountId
        this.selectedAccountName = `${this.accountList[0].realName} (${this.accountList[0].bankAccount})`
      }
    },
    calcFee () {
      const money = parseFloat(this.form.money) || 0
      if (money > 0) {
        const fee = (this.serviceFee + money * 0.09).toFixed(2)
        this.totalFeeDisplayText = `手续费${(this.serviceFee).toFixed(2)} 、个税${(money * 0.09).toFixed(2)}`
        this.totalFeeDisplay = `${fee}`
        this.totalMoneyDisplay = `-${(money + parseFloat(fee)).toFixed(2)}`
        this.totalBankDisplay = `${(money).toFixed(2)}`
      } else {
        this.totalFeeDisplayText = ''
        this.totalFeeDisplay = ''
        this.totalMoneyDisplay = ''
        this.totalBankDisplay = ''
      }
    },
    onAccountConfirm (item) {
      this.form.accountId = item.value
      this.selectedAccountName = item.text
      this.showAccountPicker = false
    },
    async onSubmit () {
      if (!this.form.money || !this.form.accountId) {
        this.$toast('请填写完整信息')
        return
      }
      const userId = (this.$store.state.userID || '').split('a')[0]
      if (!userId) {
        this.$toast('请登录后操作！')
        return
      }
      Dialog.confirm({
        title: '是否确认提现' + parseFloat(this.form.money).toFixed(2) + '元？',
        message: '综合费用\n+' + this.totalFeeDisplay + '\n\n本次应扣款\n' + this.totalMoneyDisplay
      }).then(() => {
        this.confirmWithdrawalSubmit(userId)
      })
    },
    async confirmWithdrawalSubmit (userId) {
      this.submitting = true
      try {
        const {
          data: response
        } = await withdrawalSubmit({
          money: this.form.money,
          accountId: this.form.accountId,
          token: this.$store.state.token,
          userId
        })
        if (response.code === 0) {
          this.$toast.success('已提交申请')
          this.form.money = ''
          this.$nextTick(() => {
            this.calcFee()
            this.$emit('submit')
          })
        } else {
          this.$toast.fail(response.msg || '提现失败')
        }
      } catch (e) {
        this.$toast.fail(e.msg || '提现失败')
      } finally {
        this.submitting = false
      }
    },
    formatMoney (val) {
      return (val / 1).toFixed(2)
    }
  }
}
</script>

<style scoped>
  /* 页面根容器 - 微信环境专属适配 */
  .withdrawal-page {
    /* 1. 全屏布局：占满微信可视区域 */
    min-height: 100vh;
    width: 100%;
    box-sizing: border-box;

    /* 2. 微信安全区适配（依赖 viewport-fit=cover） */
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);

    /* 3. 背景色统一，避免微信默认白底与组件灰色间隙 */
    background-color: #f7f8fa;

    /* 4. 微信内滚动优化：防止滚动穿透 & 卡顿 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none;

    /* 5. 禁止微信长按弹出菜单/选中文字（表单页防误触） */
    -webkit-user-select: none;
    user-select: none;

    /* 6. 隐藏微信内置滚动条（iOS） */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .withdrawal-page::-webkit-scrollbar {
    display: none;
  }
/* 微信安全区全局适配 */
.safe-area-wrapper {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  min-height: 80vh;
  background: #f7f8fa;
}
.safe-area-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
}

.btn-area {
  margin: 150px 16px 0;
}

.rule-section {
  margin: 16px;
  background: #fff;
  padding: 14px;
  border-radius: 8px;
  border: 1px dashed #e6e6e6;
  font-size: 13px;
  line-height: 1.8;
}
.rule-item { display: flex; align-items: flex-start; gap: 6px; margin-bottom: 6px; }
.rule-fee { margin-top: 8px; padding-top: 8px; border-top: 1px dashed #eee; }
.rule-label { font-weight: bold; color: #333; white-space: nowrap; }
.highlight { color: #FF5722; font-weight: bold; }
.fee-text { color: #FF5722; }

/* .total-text::v-deep .van-field__label{ color: #FF5722!important; } */

.total-text::v-deep .van-field__control{ -webkit-text-fill-color: #FF5722!important; }

.total-bank-text::v-deep .van-field__control{ -webkit-text-fill-color: #07c160!important; }

/* 微信浏览器输入框字体大小修复（防止自动缩放） */
::v-deep .van-field__control {
  font-size: 28px !important;
}
</style>
